export type GetReportHandler = () => void | Promise<void>;

export function resolveGetReportHandler(
  providerHandler: GetReportHandler,
  callerHandler?: GetReportHandler,
): GetReportHandler {
  return callerHandler ?? providerHandler;
}
